module.exports = __webpack_public_path__ + "media/home.518d7832.mp3";